export default __webpack_public_path__ + "static/media/kimono-gb8735578a_1280.d19bcfe0.jpg";